import React, { Component } from 'react'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'

class PresupuestoColorLegenda extends Component {
    constructor(props) {
        super(props)
        this.state = {
            porcentaje: ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
        }
    }

    render() {
        var pct = this.state.porcentaje
        var estados = [
            { color: 'gray',    bg: 'rgba(128,128,128,0.08)', label: 'Sin asignar', tooltip: 'Sin Presupuesto Asignado'                              },
            { color: '#474789', bg: 'rgba(71,71,137,0.08)',   label: 'Intacto',     tooltip: '100% del Presupuesto disponible'                      },
            { color: '#28D094', bg: 'rgba(40,208,148,0.08)',  label: 'Disponible',  tooltip: 'Más del ' + pct + '% del Presupuesto disponible'      },
            { color: '#D4B800', bg: 'rgba(241,234,127,0.25)', label: 'Alerta',      tooltip: 'Menos del ' + pct + '% del Presupuesto disponible'    },
            { color: '#FF4961', bg: 'rgba(255,73,97,0.08)',   label: 'Agotado',     tooltip: 'Sin Presupuesto Disponible o excedido'                 },
        ]

        return (
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '6px' }}>
                <span style={{ fontSize: '0.9rem', color: '#6b6f82', marginRight: '2px' }}>Estado:</span>
                {estados.map(function(estado) {
                    return (
                        <div
                            key={estado.color}
                            title={estado.tooltip}
                            style={{
                                display:         'flex',
                                alignItems:      'center',
                                border:          '1px solid ' + estado.color,
                                borderRadius:    '20px',
                                padding:         '4px 12px',
                                gap:             '6px',
                                backgroundColor: estado.bg,
                                cursor:          'default',
                            }}
                        >
                            <div style={{
                                width:           '10px',
                                height:          '10px',
                                borderRadius:    '50%',
                                backgroundColor: estado.color,
                                flexShrink:      0,
                            }} />
                            <span style={{ fontSize: '0.9rem', color: estado.color, whiteSpace: 'nowrap' }}>{estado.label}</span>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default PresupuestoColorLegenda
